import { Tabs } from 'antd'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSchool, faUser } from '@fortawesome/pro-solid-svg-icons'

import MaccsUsers from '../../../Components/shared/MaccsUsers'
import MaccsSchoolsView from '../../../Components/MACCS/Settings/School/MaccsSchoolsView'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const { TabPane } = Tabs

const USER_TAB_NAME = 'Manage users'
const IDENTITY_TAB_NAME = 'School identity'
const TAB_STYLE = { marginTop: '3px' }

const MaccsSchoolSettingsView = props => {
  const t = useSelector(selectTranslate)

  return (
    <Tabs defaultActiveKey='1' animated={false}>
      <TabPane
        key='1'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faUser} style={TAB_STYLE} />
            <div className='h-spacing' />
            {t(USER_TAB_NAME)}
          </div>
        }
      >
        <MaccsUsers />
      </TabPane>
      <TabPane
        key='2'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faSchool} style={TAB_STYLE} />
            <div className='h-spacing' />
            {t(IDENTITY_TAB_NAME)}
          </div>
        }
      >
        <MaccsSchoolsView />
      </TabPane>
    </Tabs>
  )
}

export default MaccsSchoolSettingsView
